import React, {Component} from 'react';
import LoadingPage from "../../components/LoadingPage";
import apiMyAccount from "../../api/MyAccount";

const styleHtml = `<style>
table{
    border: #F15922 1px solid;
    width:100%
}
table th{
background-color: #F15922;
    color: #ffffff;
    border-color: #f7a182;
    text-align: center;
    padding: 7px;
    border-width: 1px;
    border-style: solid;
}
    table td{
    border-color: #F15922;
    border-right-color: #f7a182;
        text-align: center;
    padding: 7px;
    border-width: 1px;
    border-style: solid;
}
</style>`;

class GuideContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: '',
            title: '',
            loading: true,
        };
    }

    async componentDidMount() {
        const id = this.props.match.params.id;
        try {
            const data = await apiMyAccount.getArticleDetail(id);
            if (data.data.code === 0) {
                this.setState({
                    content: data.data.data.content,
                    title: data.data.data.title,
                    loading: false,
                });
            } else {
                this.setState({ loading: false });
            }
        } catch (e) {
            this.setState({ loading: false });
        }
    }

    render() {
        if (this.state.loading) {
            return <LoadingPage />;
        }

        return (
            <div className="p2">
                {this.state.title ? (
                    <h4 className="font-weight-bold mb-3">{this.state.title}</h4>
                ) : null}
                <div dangerouslySetInnerHTML={{ __html: styleHtml + this.state.content }} />
            </div>
        );
    }
}

export default GuideContent;
